import { Location } from '@umss/shared/data-access';
import { ContractorStatus } from '@umss/shared/data-access';
import { AdminNoteDto } from '../common/admin-note.dto';
import { ContractorBankAccountDto } from '../common/contractor-bank-account.dto';
import { ContractorAdminDto } from './contractor-admin.dto';

export interface ContractorAdminDetailDto extends ContractorAdminDto {
  primaryLocation?: Location;
  certifications: string[];
  skills: string[];
  averageRating: number;
  totalRatings: number;
  lastBackgroundCheck?: string | null; // DateTime as ISO string
  /**
   * Last four SSN digits only — the API never sends the full number to a
   * business admin (see ContractorDtoRedactor). Null when not permitted.
   */
  ssnLast4?: string | null;
  notes: AdminNoteDto[];
  primaryBankAccount?: ContractorBankAccountDto | null;
  /** Reason the admin gave when deactivating this contractor. Null unless status is Inactive via deactivation. */
  deactivationReason?: string | null;
  /** UTC timestamp when the contractor was deactivated. */
  deactivatedAt?: string | null;
  /** Display name of the administrator who deactivated the contractor. */
  deactivatedByName?: string | null;
}

export interface ContractorStatusUpdateResultDto {
  status: ContractorStatus;
  deactivationReason?: string | null;
  deactivatedAt?: string | null;
  deactivatedByName?: string | null;
}
